import React from 'react';
import PropTypes from 'prop-types';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';

const Alert = React.forwardRef((props, ref) => (
  <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />
));

function ErrorSnackBar(props) {
  const { opensnackbar, handleClose } = props;

  const snackbars = Array.isArray(opensnackbar)
    ? opensnackbar
    : opensnackbar
    ? [opensnackbar]
    : [];

  const activeSnackbars = snackbars.filter((s) => s?.setopen);

  return (
    <Stack
      spacing={2}
      sx={{
        position: 'fixed',
        bottom: 24,
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 1400,
        alignItems: 'center',
        maxWidth: '100vw',
      }}
    >
      {activeSnackbars
        .slice()
        .reverse()
        .map((snackbar) => (
          <Snackbar
            key={snackbar.id || 'single'}
            open
            autoHideDuration={snackbar.duration || 4000}
            onClose={(event, reason) => handleClose(snackbar.id, reason)}
            sx={{ position: 'static' }}
          >
            <Alert
              onClose={(event, reason) => handleClose(snackbar.id, reason)}
              severity={snackbar.severity}
              sx={{ width: '100%' }}
            >
              {snackbar.message}
            </Alert>
          </Snackbar>
        ))}
    </Stack>
  );
}

ErrorSnackBar.propTypes = {
  opensnackbar: PropTypes.oneOfType([
    PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        message: PropTypes.string.isRequired,
        severity: PropTypes.string,
        duration: PropTypes.number,
        setopen: PropTypes.bool,
      })
    ),
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      message: PropTypes.string.isRequired,
      severity: PropTypes.string,
      duration: PropTypes.number,
      setopen: PropTypes.bool,
    }),
  ]),
  handleClose: PropTypes.func.isRequired,
};

ErrorSnackBar.defaultProps = {
  opensnackbar: [],
};

export default ErrorSnackBar;
